module.exports = function() {
  return new Worker(__webpack_public_path__ + "bf7e3b87da798adbaceb.worker.js");
};